module.exports = __webpack_public_path__ + "img/shutterstock_1776375335.ef0e9bbc.jpg";